import { Toaster, toast, type ToasterProps } from 'sonner'

export type ToasterPropsWithAutoClose = ToasterProps & {
  cancelAutoClose?: boolean
}

const ClassicToast = (message: string, options?: ToasterPropsWithAutoClose) => {
  return toast.success(message, {
    ...options,
    ...(options?.cancelAutoClose && { duration: Infinity }),
  })
}

const ErrorToast = (message: string, options?: ToasterPropsWithAutoClose) => {
  return toast.error(message, {
    richColors: true,
    ...options,
    ...(options?.cancelAutoClose && { duration: Infinity }),
  })
}

const SuccessToast = (message: string, options?: ToasterPropsWithAutoClose) => {
  return toast.success(message, {
    richColors: true,
    ...options,
    ...(options?.cancelAutoClose && { duration: Infinity }),
  })
}

const WarningToast = (message: string, options?: ToasterPropsWithAutoClose) => {
  return toast.warning(message, {
    richColors: true,
    ...options,
    ...(options?.cancelAutoClose && { duration: Infinity }),
  })
}

const InfoToast = (message: string, options?: ToasterPropsWithAutoClose) => {
  return toast.info(message, {
    richColors: true,
    ...options,
    ...(options?.cancelAutoClose && { duration: Infinity }),
  })
}

const LoadingToast = (message: string, options?: ToasterPropsWithAutoClose) => {
  return toast.loading(message, {
    richColors: true,
    ...options,
    ...(options?.cancelAutoClose && { duration: Infinity }),
  })
}

const DismissToast = (id?: string) => {
  return toast.dismiss(id || undefined)
}

export const Toast: {
  Root: typeof Toaster
  classic: typeof ClassicToast
  error: typeof ErrorToast
  success: typeof SuccessToast
  warning: typeof WarningToast
  info: typeof InfoToast
  loading: typeof LoadingToast
  dismiss: typeof DismissToast
  custom: typeof toast
} = {
  Root: Toaster,
  classic: ClassicToast,
  error: ErrorToast,
  success: SuccessToast,
  warning: WarningToast,
  info: InfoToast,
  loading: LoadingToast,
  dismiss: DismissToast,
  custom: toast,
}
